import React, { useState, useEffect } from "react"
import PropTypes from "prop-types"
import { useBgColorContext } from "./context"

import ServiceBrand from "./shared/service_brand"
import { fullColoredPage } from "./utils/container_background_color"
import openRemoteLinksInNewWindow from "app/scripts/open_remote_links_in_new_window"
import { checkServiceActivation } from "./api"
import { LoadLiveChannels } from "shared/components/stored_fields/service_account_select_field/api"

import { buildConnectionPath, windowFeatures } from "shared/reconnect_window"

import "./service_connection.scss"

export default function ServiceConnection({
  service,
  connectionFinishedUrl,
  onServiceConnected,
}) {
  const bgColor = useBgColorContext()

  const [connectionFailed, updateConnectionFailed] = useState(false)
  let popup = null

  useEffect(() => {
    fullColoredPage(bgColor)
    openRemoteLinksInNewWindow(".service-diy-description")

    return () => {
      fullColoredPage("initial")
    }
  }, [bgColor])

  const connectionPath = buildConnectionPath(
    service.module_name,
    null,
    connectionFinishedUrl
  )

  const onStartConnection = () => {
    if (service.can_be_autoactivated) {
      checkServiceActivation({ serviceModuleName: service.module_name })
        .then(data => {
          if (data.liveChannelCreate.live_channel?.offline === false) {
            onServiceConnected({
              ...service,
              live_channels: [data.liveChannelCreate.live_channel],
            })
          } else {
            updateConnectionFailed(true)
          }
        })
        .catch(() => updateConnectionFailed(true))
    } else if (popup == null || popup.closed) {
      popup = window.open(
        connectionPath,
        `${service.module_name}_connection`,
        windowFeatures
      )
    } else {
      popup.focus()
    }

    window.connectionFinished = () => {
      LoadLiveChannels(service.module_name).then(response => {
        if (!response.data) {
          window.appendFlash(
            `It fails to load your ${service.name}. Please, reload page and try again.`,
            "danger"
          )
        } else {
          onServiceConnected({
            ...service,
            live_channels: response.data.channel.live_channels,
          })
        }
      })
    }
    window.connectionFailed = () => updateConnectionFailed(true)
  }

  const serviceFailureMessage = `Could not connect ${service.name} right now. Please try again later.`
  return (
    <div styleName="service-connection">
      {connectionFailed && (
        <p styleName="inline-errors">{serviceFailureMessage}</p>
      )}

      <ServiceBrand title={service.name} image={service.image} />

      <p
        className="service-diy-description"
        styleName="service-description"
        dangerouslySetInnerHTML={{
          __html: service.description_html,
        }}
      />

      <button
        className="button-primary button-on-color"
        onClick={onStartConnection}
      >
        Connect
      </button>
    </div>
  )
}

ServiceConnection.propTypes = {
  connectionFinishedUrl: PropTypes.string.isRequired,
  onServiceConnected: PropTypes.func.isRequired,
  service: PropTypes.shape({
    name: PropTypes.string.isRequired,
    module_name: PropTypes.string.isRequired,
    description_html: PropTypes.string.isRequired,
    image: PropTypes.string.isRequired,
    can_be_autoactivated: PropTypes.bool.isRequired,
  }).isRequired,
}
